import * as React from "react"
import { SVGProps } from "react"

const SvgCloudDownload = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" {...props}>
    <path d="M12.55 40q-4.4 0-7.475-3.075Q2 33.85 2 29.45q0-3.95 2.525-6.875t6.325-3.525q.75-4.2 4.1-7.425Q18.3 8.4 22.55 8.4q1.2 0 2.1.675.9.675.9 1.825v14.7l4.15-4.15 2.15 2.15-7.8 7.8-7.8-7.8 2.15-2.15 4.15 4.15V11.15q-4.3.55-6.75 3.775-2.45 3.225-2.45 6.975h-.95q-3.05 0-5.225 2.15T5 29.45q0 3.25 2.25 5.4Q9.5 37 12.55 37h25q2.25 0 3.85-1.6t1.6-3.85q0-2.25-1.6-3.85t-3.85-1.6H34.4v-4.2q0-3.4-1.65-5.875T28.5 12.1V8.85q4.05 1.45 6.475 5.05 2.425 3.6 2.425 8v1.2q3.6-.1 6.1 2.3 2.5 2.4 2.5 6.15 0 3.45-2.5 5.95T37.55 40ZM24 22.65Z" />
  </svg>
)

export default SvgCloudDownload;
